<ng-container *transloco="let t">
  <div class="admin-card">
    <app-admin-actions-header (onExportToPdf)="downloadAdmins('pdf')" (onExportToXls)="downloadAdmins('xlsx')">
      <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
        <div class="pe-3">
          <app-rounded-button [label]="t('administrator.list.add.new')" [btnClass]="'rounded-button--red-outline'"
                              (onClick)="openAddNewAdmin()"><i class="bi bi-plus-circle pe-2"></i>
          </app-rounded-button>
        </div>
        <app-rounded-button [label]="t('administrator.list.add.new.organiser.admin')"
                            [btnClass]="'rounded-button--red-outline'"
                            (onClick)="openAddNewOrganiserAdmin()"><i class="bi bi-plus-circle pe-2"></i>
        </app-rounded-button>
      </div>
    </app-admin-actions-header>
    <div>
      @if ((administrators.length ?? 0) > 0) {
        <!-- Desktop -->
        <div>
          <div class="table-responsive d-xl-block d-none">
            <app-sortable-table [infiniteScrollDistance]="4" cssClass="table dark-header table-last-row-no-border"
                                infinite-scroll
                                [items]="administrators">
              <thead>
              <tr>
                <th scope="col" [sortBy]="['id']" class="id-column-width">{{ t("event.item.id") }}</th>
                <th scope="col" [sortBy]="['username']">{{ t("app.common.username") }}</th>
                <th scope="col" [sortBy]="['firstname','lastname']">{{ t("app.common.name.surname") }}</th>
                <th scope="col" [sortBy]="['phoneNumber']">{{ t("app.common.mobilePhone") }}</th>
                <th scope="col" [sortBy]="['email']">{{ t("app.common.email") }}</th>
                <th scope="col" class="role-column-width">{{ t("app.common.role") }}</th>
                <th class="more-column-width"></th>
              </tr>
              </thead>
              <tr app-table-header-separator></tr>
              <tbody>
                @for (administrator of administrators; track administrator) {
                  <tr>
                    <td class="center-align">{{ administrator.userId }}</td>
                    <td class="center-align">{{ administrator.username }}</td>
                    <td class="center-align">{{ administrator.firstname ?? "" }} {{ administrator.lastname ?? "" }}</td>
                    <td class="center-align">
                      @if (administrator.phoneNumber) {
                        <a class="text-black fw-semibold" href="tel:{{administrator.phoneNumber}}">{{
                            administrator.phoneNumber
                          }}</a>
                      } @else {
                        -
                      }
                    </td>
                    <td class="center-align" matTooltip="{{administrator.email ?? '-'}}">
                      @if (administrator.email) {
                        <a class="text-black fw-semibold" href="mailto:{{administrator.email}}" target="_blank"
                           rel="noopener noreferrer">{{
                            administrator.email
                          }}</a>
                      } @else {
                        -
                      }
                    </td>
                    <td class="center-align">
                      <div class="status-badge" [ngClass]="{'accepted': administrator.role === 'ROLE_ADMINISTRATOR',
                      'blue': administrator.role === 'ROLE_ORGANISERS_ADMINISTRATOR'}">
                    <span class="fw-bold">
                      {{ administrator.role | role | uppercase }}
                    </span>
                      </div>
                    </td>
                    <td class="text-end center-align">
                      <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                          <span class="menu-icon" id="administratorActionsDropdown" ngbDropdownToggle>
                            <i class="fas fa-ellipsis-v"></i>
                          </span>
                        <ul aria-labelledby="administratorActionsDropdown" ngbDropdownMenu>
                          @if (!(currentUserDetails?.userId === administrator.userId)) {
                            <li ngbDropdownItem (click)="openDeleteAdministratorDialog(administrator)"
                                class="cursor-pointer">
                              {{ t("app.common.delete") }}
                            </li>
                          }
                          <li ngbDropdownItem (click)="openAdminDetails(administrator)" class="cursor-pointer">
                            {{ t("administrator.list.preview") }}
                          </li>
                          @if (!(currentUserDetails?.userId === administrator.userId)) {
                            <li *ngIf="administrator.role === 'ROLE_ORGANISERS_ADMINISTRATOR'" ngbDropdownItem
                                (click)="confirmChangeRole(administrator, 'ROLE_ADMINISTRATOR')"
                                class="cursor-pointer">
                              {{ t('administrator.list.change.to.admin') }}
                            </li>
                            <li *ngIf="administrator.role === 'ROLE_ADMINISTRATOR'" ngbDropdownItem
                                (click)="confirmChangeRole(administrator, 'ROLE_ORGANISERS_ADMINISTRATOR')"
                                class="cursor-pointer">
                              {{ t('administrator.list.change.to.organiseradmin') }}
                            </li>
                          }
                        </ul>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </app-sortable-table>
          </div>
          <!-- Mobile -->
          @for (administrator of administrators; let isLast = $last; track administrator) {
            <div class="d-block d-xl-none">
              <div [class.isLastRow]="isLast" class="d-flex justify-content-center align-items-center mobile-table-row">
                <div class="flex-grow-1">
                  <div [class.isLastRow]="isLast" class="d-flex flex-column">
                    <div>
                      <strong>{{ t("event.item.id") }}:</strong>{{ administrator.userId }}
                    </div>
                    <div>
                      <strong>{{ t("app.common.username") }}:</strong>{{ administrator.username }}
                    </div>
                    <div>
                      <strong>{{ t("app.common.first.name") }}:</strong>{{ administrator.firstname ?? "-" }}
                    </div>
                    <div>
                      <strong>{{ t("app.common.last.name") }}:</strong>{{ administrator.lastname ?? "-" }}
                    </div>
                    <div>
                    </div>
                    <div>
                      <strong>{{ t("app.common.mobilePhone") }}:</strong>{{ administrator.phoneNumber ?? "-" }}
                    </div>
                    <div>
                      <strong>{{ t("app.common.email") }}:</strong>{{ administrator.email ?? "-" }}
                    </div>
                    <div>
                      <strong>{{ t("app.common.role") }}:</strong>{{ administrator.role | role }}
                    </div>
                  </div>
                </div>
                <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                    <span class="menu-icon" ngbDropdownToggle>
                      <i class="fas fa-ellipsis-v"></i>
                    </span>
                  <ul ngbDropdownMenu>
                    @if (!(currentUserDetails?.userId === administrator.userId)) {
                      <li ngbDropdownItem (click)="openDeleteAdministratorDialog(administrator)" class="cursor-pointer">
                        {{ t("app.common.delete") }}
                      </li>
                    }
                    <li ngbDropdownItem (click)="openAdminDetails(administrator)" class="cursor-pointer">
                      {{ t("administrator.list.preview") }}
                    </li>
                    @if (!(currentUserDetails?.userId === administrator.userId)) {
                      <li *ngIf="administrator.role === 'ROLE_ORGANISERS_ADMINISTRATOR'" ngbDropdownItem
                          (click)="confirmChangeRole(administrator, 'ROLE_ADMINISTRATOR')" class="cursor-pointer">
                        {{ t('administrator.list.change.to.admin') }}
                      </li>
                      <li *ngIf="administrator.role === 'ROLE_ADMINISTRATOR'" ngbDropdownItem
                          (click)="confirmChangeRole(administrator, 'ROLE_ORGANISERS_ADMINISTRATOR')"
                          class="cursor-pointer">
                        {{ t('administrator.list.change.to.organiseradmin') }}
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="pt-2 pb-4">
          <app-empty-state/>
        </div>
      }
    </div>
  </div>
</ng-container>
